/**
 * 🔑 **키 순서에 불감한 직렬화**(비교·지문 전용) — 손 복제를 멈추는 자리(적대 1R P3).
 *
 * ★`JSON.stringify` 를 그대로 쓰면 안 된다★: 같은 내용도 키 등장 순서가 다르면 다른 문자열이 나온다.
 *   저장분은 localStorage·JSONB 왕복과 merge 를 거치며 순서가 뒤바뀌므로, 그 위에서 지문을 재면
 *   ★아무도 안 고쳤는데 "바뀌었다"★ 가 상시로 뜬다.
 * ★`undefined` 는 `JSON.stringify` 규약대로 사라진다★ — 이 함수는 "부재와 명시적 undefined 를 같게
 *   본다". 그 둘을 갈라야 하는 축이 생기면 그 축을 null 로 정규화해서 넘긴다(여기 규칙을 바꾸지 않는다).
 *
 * ⚠️ ★이 파일은 잎(leaf) 이다★ — import 를 0 으로 유지한다. 지문 유틸이 무엇인가를 끌어오면
 *   순수 모듈들이 그 의존을 함께 지게 되고, 그 순간 순환의 씨앗이 된다.
 */
export function stableJson(v: unknown): string {
  if (v === null || typeof v !== "object") return JSON.stringify(v) ?? "null";
  if (Array.isArray(v)) return `[${v.map(stableJson).join(",")}]`;
  const o = v as Record<string, unknown>;
  return `{${Object.keys(o).sort().map((k) => `${JSON.stringify(k)}:${stableJson(o[k])}`).join(",")}}`;
}
